import { useState } from "react";
import { Link } from "react-router-dom";
import EventCard from "@/components/feature/EventCard";
import { events } from "@/mocks/events";
import { categories } from "@/mocks/categories";

export default function FeaturedEvents() {
  const [active, setActive] = useState("all");

  const tabs = [{ id: "all", name: "全部" }, ...categories.map((c) => ({ id: c.id, name: c.name }))];
  const list = active === "all" ? events : events.filter((item) => item.categoryId === active);

  return (
    <section id="events" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="eyebrow">
              <i className="ri-archive-2-line" aria-hidden="true"></i>
              精选档案
            </p>
            <h2 className="section-title mt-4">把一场瓜读成一条时间线</h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 self-start whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700 md:self-auto"
          >
            进入档案库
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActive(tab.id)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 font-label text-sm transition-colors duration-200 ${
                active === tab.id
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 bg-background-100 py-12 text-center font-body text-sm text-foreground-500">
            该分类下的档案正在整理中，先看看其他分类吧。
          </p>
        )}
      </div>
    </section>
  );
}